/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as authAuthImport } from './routes/(auth)/_auth'
import { Route as appAppImport } from './routes/(app)/_app'
import { Route as appAppIndexImport } from './routes/(app)/_app.index'
import { Route as authAuthLoginImport } from './routes/(auth)/_auth.login'
import { Route as appAppUserProfilImport } from './routes/(app)/_app.user-profil'
import { Route as appAppUpcomingEventsImport } from './routes/(app)/_app.upcoming-events'
import { Route as appAppRoadShowImport } from './routes/(app)/_app.roadShow'
import { Route as appAppOfflineVideosImport } from './routes/(app)/_app.offline-videos'
import { Route as appAppOfflineModeImport } from './routes/(app)/_app.offline-mode'
import { Route as appAppNotificationsImport } from './routes/(app)/_app.notifications'
import { Route as appAppMyAcademyImport } from './routes/(app)/_app.my-academy'
import { Route as appAppCoursesImport } from './routes/(app)/_app.courses'
import { Route as appAppContactImport } from './routes/(app)/_app.contact'
import { Route as appAppArticlesBriefImport } from './routes/(app)/_app.articles-brief'
import { Route as appAppArticlesImport } from './routes/(app)/_app.articles'
import { Route as appAppArticlesIndexImport } from './routes/(app)/_app.articles.index'
import { Route as appAppWorkshopsTypeImport } from './routes/(app)/_app.workshops.$type'
import { Route as appAppStudyStudyIdImport } from './routes/(app)/_app.study.$studyId'
import { Route as appAppCoursesPopImport } from './routes/(app)/_app.courses_.pop'
import { Route as appAppCoursesKursRachunkowoscImport } from './routes/(app)/_app.courses_.kurs-rachunkowosc'
import { Route as appAppCoursesKursDoradcaPodatkowyImport } from './routes/(app)/_app.courses_.kurs-doradca-podatkowy'
import { Route as appAppCourseCourseKeyImport } from './routes/(app)/_app.course.$courseKey'
import { Route as appAppArticlesArticleIdImport } from './routes/(app)/_app.articles_.$articleId'
import { Route as appAppWorkshopsTypeWorkshopIdImport } from './routes/(app)/_app.workshops_.$type.$workshopId'
import { Route as appAppWorkshopsTypeSlugIdAuthImport } from './routes/(app)/_app.workshops_.$type.$slugId.auth'

// Create Virtual Routes

const authImport = createFileRoute('/(auth)')()
const appImport = createFileRoute('/(app)')()

// Create/Update Routes

const authRoute = authImport.update({
  id: '/(auth)',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const appRoute = appImport.update({
  id: '/(app)',
  getParentRoute: () => rootRoute,
} as any)

const authAuthRoute = authAuthImport.update({
  id: '/_auth',
  getParentRoute: () => authRoute,
} as any)

const appAppRoute = appAppImport.update({
  id: '/_app',
  getParentRoute: () => appRoute,
} as any)

const appAppIndexRoute = appAppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAppRoute,
} as any)

const authAuthLoginRoute = authAuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authAuthRoute,
} as any)

const appAppUserProfilRoute = appAppUserProfilImport.update({
  id: '/user-profil',
  path: '/user-profil',
  getParentRoute: () => appAppRoute,
} as any)

const appAppUpcomingEventsRoute = appAppUpcomingEventsImport.update({
  id: '/upcoming-events',
  path: '/upcoming-events',
  getParentRoute: () => appAppRoute,
} as any)

const appAppRoadShowRoute = appAppRoadShowImport.update({
  id: '/roadShow',
  path: '/roadShow',
  getParentRoute: () => appAppRoute,
} as any)

const appAppOfflineVideosRoute = appAppOfflineVideosImport.update({
  id: '/offline-videos',
  path: '/offline-videos',
  getParentRoute: () => appAppRoute,
} as any)

const appAppOfflineModeRoute = appAppOfflineModeImport.update({
  id: '/offline-mode',
  path: '/offline-mode',
  getParentRoute: () => appAppRoute,
} as any)

const appAppNotificationsRoute = appAppNotificationsImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => appAppRoute,
} as any)

const appAppMyAcademyRoute = appAppMyAcademyImport.update({
  id: '/my-academy',
  path: '/my-academy',
  getParentRoute: () => appAppRoute,
} as any)

const appAppCoursesRoute = appAppCoursesImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => appAppRoute,
} as any)

const appAppContactRoute = appAppContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => appAppRoute,
} as any)

const appAppArticlesBriefRoute = appAppArticlesBriefImport.update({
  id: '/articles-brief',
  path: '/articles-brief',
  getParentRoute: () => appAppRoute,
} as any)

const appAppArticlesRoute = appAppArticlesImport.update({
  id: '/articles',
  path: '/articles',
  getParentRoute: () => appAppRoute,
} as any)

const appAppArticlesIndexRoute = appAppArticlesIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => appAppArticlesRoute,
} as any)

const appAppWorkshopsTypeRoute = appAppWorkshopsTypeImport.update({
  id: '/workshops/$type',
  path: '/workshops/$type',
  getParentRoute: () => appAppRoute,
} as any)

const appAppStudyStudyIdRoute = appAppStudyStudyIdImport.update({
  id: '/study/$studyId',
  path: '/study/$studyId',
  getParentRoute: () => appAppRoute,
} as any)

const appAppCoursesPopRoute = appAppCoursesPopImport.update({
  id: '/courses_/pop',
  path: '/courses/pop',
  getParentRoute: () => appAppRoute,
} as any)

const appAppCoursesKursRachunkowoscRoute =
  appAppCoursesKursRachunkowoscImport.update({
    id: '/courses_/kurs-rachunkowosc',
    path: '/courses/kurs-rachunkowosc',
    getParentRoute: () => appAppRoute,
  } as any)

const appAppCoursesKursDoradcaPodatkowyRoute =
  appAppCoursesKursDoradcaPodatkowyImport.update({
    id: '/courses_/kurs-doradca-podatkowy',
    path: '/courses/kurs-doradca-podatkowy',
    getParentRoute: () => appAppRoute,
  } as any)

const appAppCourseCourseKeyRoute = appAppCourseCourseKeyImport.update({
  id: '/course/$courseKey',
  path: '/course/$courseKey',
  getParentRoute: () => appAppRoute,
} as any)

const appAppArticlesArticleIdRoute = appAppArticlesArticleIdImport.update({
  id: '/articles_/$articleId',
  path: '/articles/$articleId',
  getParentRoute: () => appAppRoute,
} as any)

const appAppWorkshopsTypeWorkshopIdRoute =
  appAppWorkshopsTypeWorkshopIdImport.update({
    id: '/workshops_/$type/$workshopId',
    path: '/workshops/$type/$workshopId',
    getParentRoute: () => appAppRoute,
  } as any)

const appAppWorkshopsTypeSlugIdAuthRoute =
  appAppWorkshopsTypeSlugIdAuthImport.update({
    id: '/workshops_/$type/$slugId/auth',
    path: '/workshops/$type/$slugId/auth',
    getParentRoute: () => appAppRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appImport
      parentRoute: typeof rootRoute
    }
    '/(app)/_app': {
      id: '/(app)/_app'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appAppImport
      parentRoute: typeof appRoute
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/_auth': {
      id: '/(auth)/_auth'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authAuthImport
      parentRoute: typeof authRoute
    }
    '/(app)/_app/articles': {
      id: '/(app)/_app/articles'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof appAppArticlesImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/articles-brief': {
      id: '/(app)/_app/articles-brief'
      path: '/articles-brief'
      fullPath: '/articles-brief'
      preLoaderRoute: typeof appAppArticlesBriefImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/contact': {
      id: '/(app)/_app/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof appAppContactImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/courses': {
      id: '/(app)/_app/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof appAppCoursesImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/my-academy': {
      id: '/(app)/_app/my-academy'
      path: '/my-academy'
      fullPath: '/my-academy'
      preLoaderRoute: typeof appAppMyAcademyImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/notifications': {
      id: '/(app)/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof appAppNotificationsImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/offline-mode': {
      id: '/(app)/_app/offline-mode'
      path: '/offline-mode'
      fullPath: '/offline-mode'
      preLoaderRoute: typeof appAppOfflineModeImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/offline-videos': {
      id: '/(app)/_app/offline-videos'
      path: '/offline-videos'
      fullPath: '/offline-videos'
      preLoaderRoute: typeof appAppOfflineVideosImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/roadShow': {
      id: '/(app)/_app/roadShow'
      path: '/roadShow'
      fullPath: '/roadShow'
      preLoaderRoute: typeof appAppRoadShowImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/upcoming-events': {
      id: '/(app)/_app/upcoming-events'
      path: '/upcoming-events'
      fullPath: '/upcoming-events'
      preLoaderRoute: typeof appAppUpcomingEventsImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/user-profil': {
      id: '/(app)/_app/user-profil'
      path: '/user-profil'
      fullPath: '/user-profil'
      preLoaderRoute: typeof appAppUserProfilImport
      parentRoute: typeof appAppImport
    }
    '/(auth)/_auth/login': {
      id: '/(auth)/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authAuthLoginImport
      parentRoute: typeof authAuthImport
    }
    '/(app)/_app/': {
      id: '/(app)/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appAppIndexImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/articles_/$articleId': {
      id: '/(app)/_app/articles_/$articleId'
      path: '/articles/$articleId'
      fullPath: '/articles/$articleId'
      preLoaderRoute: typeof appAppArticlesArticleIdImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/course/$courseKey': {
      id: '/(app)/_app/course/$courseKey'
      path: '/course/$courseKey'
      fullPath: '/course/$courseKey'
      preLoaderRoute: typeof appAppCourseCourseKeyImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/courses_/kurs-doradca-podatkowy': {
      id: '/(app)/_app/courses_/kurs-doradca-podatkowy'
      path: '/courses/kurs-doradca-podatkowy'
      fullPath: '/courses/kurs-doradca-podatkowy'
      preLoaderRoute: typeof appAppCoursesKursDoradcaPodatkowyImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/courses_/kurs-rachunkowosc': {
      id: '/(app)/_app/courses_/kurs-rachunkowosc'
      path: '/courses/kurs-rachunkowosc'
      fullPath: '/courses/kurs-rachunkowosc'
      preLoaderRoute: typeof appAppCoursesKursRachunkowoscImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/courses_/pop': {
      id: '/(app)/_app/courses_/pop'
      path: '/courses/pop'
      fullPath: '/courses/pop'
      preLoaderRoute: typeof appAppCoursesPopImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/study/$studyId': {
      id: '/(app)/_app/study/$studyId'
      path: '/study/$studyId'
      fullPath: '/study/$studyId'
      preLoaderRoute: typeof appAppStudyStudyIdImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/workshops/$type': {
      id: '/(app)/_app/workshops/$type'
      path: '/workshops/$type'
      fullPath: '/workshops/$type'
      preLoaderRoute: typeof appAppWorkshopsTypeImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/articles/': {
      id: '/(app)/_app/articles/'
      path: '/'
      fullPath: '/articles/'
      preLoaderRoute: typeof appAppArticlesIndexImport
      parentRoute: typeof appAppArticlesImport
    }
    '/(app)/_app/workshops_/$type/$workshopId': {
      id: '/(app)/_app/workshops_/$type/$workshopId'
      path: '/workshops/$type/$workshopId'
      fullPath: '/workshops/$type/$workshopId'
      preLoaderRoute: typeof appAppWorkshopsTypeWorkshopIdImport
      parentRoute: typeof appAppImport
    }
    '/(app)/_app/workshops_/$type/$slugId/auth': {
      id: '/(app)/_app/workshops_/$type/$slugId/auth'
      path: '/workshops/$type/$slugId/auth'
      fullPath: '/workshops/$type/$slugId/auth'
      preLoaderRoute: typeof appAppWorkshopsTypeSlugIdAuthImport
      parentRoute: typeof appAppImport
    }
  }
}

// Create and export the route tree

interface appAppArticlesRouteChildren {
  appAppArticlesIndexRoute: typeof appAppArticlesIndexRoute
}

const appAppArticlesRouteChildren: appAppArticlesRouteChildren = {
  appAppArticlesIndexRoute: appAppArticlesIndexRoute,
}

const appAppArticlesRouteWithChildren = appAppArticlesRoute._addFileChildren(
  appAppArticlesRouteChildren,
)

interface appAppRouteChildren {
  appAppArticlesRoute: typeof appAppArticlesRouteWithChildren
  appAppArticlesBriefRoute: typeof appAppArticlesBriefRoute
  appAppContactRoute: typeof appAppContactRoute
  appAppCoursesRoute: typeof appAppCoursesRoute
  appAppMyAcademyRoute: typeof appAppMyAcademyRoute
  appAppNotificationsRoute: typeof appAppNotificationsRoute
  appAppOfflineModeRoute: typeof appAppOfflineModeRoute
  appAppOfflineVideosRoute: typeof appAppOfflineVideosRoute
  appAppRoadShowRoute: typeof appAppRoadShowRoute
  appAppUpcomingEventsRoute: typeof appAppUpcomingEventsRoute
  appAppUserProfilRoute: typeof appAppUserProfilRoute
  appAppIndexRoute: typeof appAppIndexRoute
  appAppArticlesArticleIdRoute: typeof appAppArticlesArticleIdRoute
  appAppCourseCourseKeyRoute: typeof appAppCourseCourseKeyRoute
  appAppCoursesKursDoradcaPodatkowyRoute: typeof appAppCoursesKursDoradcaPodatkowyRoute
  appAppCoursesKursRachunkowoscRoute: typeof appAppCoursesKursRachunkowoscRoute
  appAppCoursesPopRoute: typeof appAppCoursesPopRoute
  appAppStudyStudyIdRoute: typeof appAppStudyStudyIdRoute
  appAppWorkshopsTypeRoute: typeof appAppWorkshopsTypeRoute
  appAppWorkshopsTypeWorkshopIdRoute: typeof appAppWorkshopsTypeWorkshopIdRoute
  appAppWorkshopsTypeSlugIdAuthRoute: typeof appAppWorkshopsTypeSlugIdAuthRoute
}

const appAppRouteChildren: appAppRouteChildren = {
  appAppArticlesRoute: appAppArticlesRouteWithChildren,
  appAppArticlesBriefRoute: appAppArticlesBriefRoute,
  appAppContactRoute: appAppContactRoute,
  appAppCoursesRoute: appAppCoursesRoute,
  appAppMyAcademyRoute: appAppMyAcademyRoute,
  appAppNotificationsRoute: appAppNotificationsRoute,
  appAppOfflineModeRoute: appAppOfflineModeRoute,
  appAppOfflineVideosRoute: appAppOfflineVideosRoute,
  appAppRoadShowRoute: appAppRoadShowRoute,
  appAppUpcomingEventsRoute: appAppUpcomingEventsRoute,
  appAppUserProfilRoute: appAppUserProfilRoute,
  appAppIndexRoute: appAppIndexRoute,
  appAppArticlesArticleIdRoute: appAppArticlesArticleIdRoute,
  appAppCourseCourseKeyRoute: appAppCourseCourseKeyRoute,
  appAppCoursesKursDoradcaPodatkowyRoute:
    appAppCoursesKursDoradcaPodatkowyRoute,
  appAppCoursesKursRachunkowoscRoute: appAppCoursesKursRachunkowoscRoute,
  appAppCoursesPopRoute: appAppCoursesPopRoute,
  appAppStudyStudyIdRoute: appAppStudyStudyIdRoute,
  appAppWorkshopsTypeRoute: appAppWorkshopsTypeRoute,
  appAppWorkshopsTypeWorkshopIdRoute: appAppWorkshopsTypeWorkshopIdRoute,
  appAppWorkshopsTypeSlugIdAuthRoute: appAppWorkshopsTypeSlugIdAuthRoute,
}

const appAppRouteWithChildren =
  appAppRoute._addFileChildren(appAppRouteChildren)

interface appRouteChildren {
  appAppRoute: typeof appAppRouteWithChildren
}

const appRouteChildren: appRouteChildren = {
  appAppRoute: appAppRouteWithChildren,
}

const appRouteWithChildren = appRoute._addFileChildren(appRouteChildren)

interface authAuthRouteChildren {
  authAuthLoginRoute: typeof authAuthLoginRoute
}

const authAuthRouteChildren: authAuthRouteChildren = {
  authAuthLoginRoute: authAuthLoginRoute,
}

const authAuthRouteWithChildren = authAuthRoute._addFileChildren(
  authAuthRouteChildren,
)

interface authRouteChildren {
  authAuthRoute: typeof authAuthRouteWithChildren
}

const authRouteChildren: authRouteChildren = {
  authAuthRoute: authAuthRouteWithChildren,
}

const authRouteWithChildren = authRoute._addFileChildren(authRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof appAppIndexRoute
  '/articles': typeof appAppArticlesRouteWithChildren
  '/articles-brief': typeof appAppArticlesBriefRoute
  '/contact': typeof appAppContactRoute
  '/courses': typeof appAppCoursesRoute
  '/my-academy': typeof appAppMyAcademyRoute
  '/notifications': typeof appAppNotificationsRoute
  '/offline-mode': typeof appAppOfflineModeRoute
  '/offline-videos': typeof appAppOfflineVideosRoute
  '/roadShow': typeof appAppRoadShowRoute
  '/upcoming-events': typeof appAppUpcomingEventsRoute
  '/user-profil': typeof appAppUserProfilRoute
  '/login': typeof authAuthLoginRoute
  '/articles/$articleId': typeof appAppArticlesArticleIdRoute
  '/course/$courseKey': typeof appAppCourseCourseKeyRoute
  '/courses/kurs-doradca-podatkowy': typeof appAppCoursesKursDoradcaPodatkowyRoute
  '/courses/kurs-rachunkowosc': typeof appAppCoursesKursRachunkowoscRoute
  '/courses/pop': typeof appAppCoursesPopRoute
  '/study/$studyId': typeof appAppStudyStudyIdRoute
  '/workshops/$type': typeof appAppWorkshopsTypeRoute
  '/articles/': typeof appAppArticlesIndexRoute
  '/workshops/$type/$workshopId': typeof appAppWorkshopsTypeWorkshopIdRoute
  '/workshops/$type/$slugId/auth': typeof appAppWorkshopsTypeSlugIdAuthRoute
}

export interface FileRoutesByTo {
  '/': typeof appAppIndexRoute
  '/articles-brief': typeof appAppArticlesBriefRoute
  '/contact': typeof appAppContactRoute
  '/courses': typeof appAppCoursesRoute
  '/my-academy': typeof appAppMyAcademyRoute
  '/notifications': typeof appAppNotificationsRoute
  '/offline-mode': typeof appAppOfflineModeRoute
  '/offline-videos': typeof appAppOfflineVideosRoute
  '/roadShow': typeof appAppRoadShowRoute
  '/upcoming-events': typeof appAppUpcomingEventsRoute
  '/user-profil': typeof appAppUserProfilRoute
  '/login': typeof authAuthLoginRoute
  '/articles/$articleId': typeof appAppArticlesArticleIdRoute
  '/course/$courseKey': typeof appAppCourseCourseKeyRoute
  '/courses/kurs-doradca-podatkowy': typeof appAppCoursesKursDoradcaPodatkowyRoute
  '/courses/kurs-rachunkowosc': typeof appAppCoursesKursRachunkowoscRoute
  '/courses/pop': typeof appAppCoursesPopRoute
  '/study/$studyId': typeof appAppStudyStudyIdRoute
  '/workshops/$type': typeof appAppWorkshopsTypeRoute
  '/articles': typeof appAppArticlesIndexRoute
  '/workshops/$type/$workshopId': typeof appAppWorkshopsTypeWorkshopIdRoute
  '/workshops/$type/$slugId/auth': typeof appAppWorkshopsTypeSlugIdAuthRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/(app)': typeof appRouteWithChildren
  '/(app)/_app': typeof appAppRouteWithChildren
  '/(auth)': typeof authRouteWithChildren
  '/(auth)/_auth': typeof authAuthRouteWithChildren
  '/(app)/_app/articles': typeof appAppArticlesRouteWithChildren
  '/(app)/_app/articles-brief': typeof appAppArticlesBriefRoute
  '/(app)/_app/contact': typeof appAppContactRoute
  '/(app)/_app/courses': typeof appAppCoursesRoute
  '/(app)/_app/my-academy': typeof appAppMyAcademyRoute
  '/(app)/_app/notifications': typeof appAppNotificationsRoute
  '/(app)/_app/offline-mode': typeof appAppOfflineModeRoute
  '/(app)/_app/offline-videos': typeof appAppOfflineVideosRoute
  '/(app)/_app/roadShow': typeof appAppRoadShowRoute
  '/(app)/_app/upcoming-events': typeof appAppUpcomingEventsRoute
  '/(app)/_app/user-profil': typeof appAppUserProfilRoute
  '/(auth)/_auth/login': typeof authAuthLoginRoute
  '/(app)/_app/': typeof appAppIndexRoute
  '/(app)/_app/articles_/$articleId': typeof appAppArticlesArticleIdRoute
  '/(app)/_app/course/$courseKey': typeof appAppCourseCourseKeyRoute
  '/(app)/_app/courses_/kurs-doradca-podatkowy': typeof appAppCoursesKursDoradcaPodatkowyRoute
  '/(app)/_app/courses_/kurs-rachunkowosc': typeof appAppCoursesKursRachunkowoscRoute
  '/(app)/_app/courses_/pop': typeof appAppCoursesPopRoute
  '/(app)/_app/study/$studyId': typeof appAppStudyStudyIdRoute
  '/(app)/_app/workshops/$type': typeof appAppWorkshopsTypeRoute
  '/(app)/_app/articles/': typeof appAppArticlesIndexRoute
  '/(app)/_app/workshops_/$type/$workshopId': typeof appAppWorkshopsTypeWorkshopIdRoute
  '/(app)/_app/workshops_/$type/$slugId/auth': typeof appAppWorkshopsTypeSlugIdAuthRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/articles'
    | '/articles-brief'
    | '/contact'
    | '/courses'
    | '/my-academy'
    | '/notifications'
    | '/offline-mode'
    | '/offline-videos'
    | '/roadShow'
    | '/upcoming-events'
    | '/user-profil'
    | '/login'
    | '/articles/$articleId'
    | '/course/$courseKey'
    | '/courses/kurs-doradca-podatkowy'
    | '/courses/kurs-rachunkowosc'
    | '/courses/pop'
    | '/study/$studyId'
    | '/workshops/$type'
    | '/articles/'
    | '/workshops/$type/$workshopId'
    | '/workshops/$type/$slugId/auth'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/articles-brief'
    | '/contact'
    | '/courses'
    | '/my-academy'
    | '/notifications'
    | '/offline-mode'
    | '/offline-videos'
    | '/roadShow'
    | '/upcoming-events'
    | '/user-profil'
    | '/login'
    | '/articles/$articleId'
    | '/course/$courseKey'
    | '/courses/kurs-doradca-podatkowy'
    | '/courses/kurs-rachunkowosc'
    | '/courses/pop'
    | '/study/$studyId'
    | '/workshops/$type'
    | '/articles'
    | '/workshops/$type/$workshopId'
    | '/workshops/$type/$slugId/auth'
  id:
    | '__root__'
    | '/(app)'
    | '/(app)/_app'
    | '/(auth)'
    | '/(auth)/_auth'
    | '/(app)/_app/articles'
    | '/(app)/_app/articles-brief'
    | '/(app)/_app/contact'
    | '/(app)/_app/courses'
    | '/(app)/_app/my-academy'
    | '/(app)/_app/notifications'
    | '/(app)/_app/offline-mode'
    | '/(app)/_app/offline-videos'
    | '/(app)/_app/roadShow'
    | '/(app)/_app/upcoming-events'
    | '/(app)/_app/user-profil'
    | '/(auth)/_auth/login'
    | '/(app)/_app/'
    | '/(app)/_app/articles_/$articleId'
    | '/(app)/_app/course/$courseKey'
    | '/(app)/_app/courses_/kurs-doradca-podatkowy'
    | '/(app)/_app/courses_/kurs-rachunkowosc'
    | '/(app)/_app/courses_/pop'
    | '/(app)/_app/study/$studyId'
    | '/(app)/_app/workshops/$type'
    | '/(app)/_app/articles/'
    | '/(app)/_app/workshops_/$type/$workshopId'
    | '/(app)/_app/workshops_/$type/$slugId/auth'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  appRoute: typeof appRouteWithChildren
  authRoute: typeof authRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  appRoute: appRouteWithChildren,
  authRoute: authRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/(app)",
        "/(auth)"
      ]
    },
    "/(app)": {
      "filePath": "(app)",
      "children": [
        "/(app)/_app"
      ]
    },
    "/(app)/_app": {
      "filePath": "(app)/_app.tsx",
      "parent": "/(app)",
      "children": [
        "/(app)/_app/articles",
        "/(app)/_app/articles-brief",
        "/(app)/_app/contact",
        "/(app)/_app/courses",
        "/(app)/_app/my-academy",
        "/(app)/_app/notifications",
        "/(app)/_app/offline-mode",
        "/(app)/_app/offline-videos",
        "/(app)/_app/roadShow",
        "/(app)/_app/upcoming-events",
        "/(app)/_app/user-profil",
        "/(app)/_app/",
        "/(app)/_app/articles_/$articleId",
        "/(app)/_app/course/$courseKey",
        "/(app)/_app/courses_/kurs-doradca-podatkowy",
        "/(app)/_app/courses_/kurs-rachunkowosc",
        "/(app)/_app/courses_/pop",
        "/(app)/_app/study/$studyId",
        "/(app)/_app/workshops/$type",
        "/(app)/_app/workshops_/$type/$workshopId",
        "/(app)/_app/workshops_/$type/$slugId/auth"
      ]
    },
    "/(auth)": {
      "filePath": "(auth)",
      "children": [
        "/(auth)/_auth"
      ]
    },
    "/(auth)/_auth": {
      "filePath": "(auth)/_auth.tsx",
      "parent": "/(auth)",
      "children": [
        "/(auth)/_auth/login"
      ]
    },
    "/(app)/_app/articles": {
      "filePath": "(app)/_app.articles.tsx",
      "parent": "/(app)/_app",
      "children": [
        "/(app)/_app/articles/"
      ]
    },
    "/(app)/_app/articles-brief": {
      "filePath": "(app)/_app.articles-brief.ts",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/contact": {
      "filePath": "(app)/_app.contact.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/courses": {
      "filePath": "(app)/_app.courses.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/my-academy": {
      "filePath": "(app)/_app.my-academy.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/notifications": {
      "filePath": "(app)/_app.notifications.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/offline-mode": {
      "filePath": "(app)/_app.offline-mode.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/offline-videos": {
      "filePath": "(app)/_app.offline-videos.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/roadShow": {
      "filePath": "(app)/_app.roadShow.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/upcoming-events": {
      "filePath": "(app)/_app.upcoming-events.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/user-profil": {
      "filePath": "(app)/_app.user-profil.ts",
      "parent": "/(app)/_app"
    },
    "/(auth)/_auth/login": {
      "filePath": "(auth)/_auth.login.ts",
      "parent": "/(auth)/_auth"
    },
    "/(app)/_app/": {
      "filePath": "(app)/_app.index.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/articles_/$articleId": {
      "filePath": "(app)/_app.articles_.$articleId.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/course/$courseKey": {
      "filePath": "(app)/_app.course.$courseKey.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/courses_/kurs-doradca-podatkowy": {
      "filePath": "(app)/_app.courses_.kurs-doradca-podatkowy.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/courses_/kurs-rachunkowosc": {
      "filePath": "(app)/_app.courses_.kurs-rachunkowosc.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/courses_/pop": {
      "filePath": "(app)/_app.courses_.pop.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/study/$studyId": {
      "filePath": "(app)/_app.study.$studyId.tsx",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/workshops/$type": {
      "filePath": "(app)/_app.workshops.$type.ts",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/articles/": {
      "filePath": "(app)/_app.articles.index.tsx",
      "parent": "/(app)/_app/articles"
    },
    "/(app)/_app/workshops_/$type/$workshopId": {
      "filePath": "(app)/_app.workshops_.$type.$workshopId.ts",
      "parent": "/(app)/_app"
    },
    "/(app)/_app/workshops_/$type/$slugId/auth": {
      "filePath": "(app)/_app.workshops_.$type.$slugId.auth.tsx",
      "parent": "/(app)/_app"
    }
  }
}
ROUTE_MANIFEST_END */
